import { loadMiniProgramBridge } from "./miniProgramEnv";

const MINIAPP_PAY_PAGE_PATH = "/pages/pay/index";

export type MiniProgramPayLaunchOptions = {
  spaceId: string;
  orderId: string;
  /** 支付完成后 web-view 应停留的 H5 路径（含 query） */
  returnPath?: string;
};

function buildMiniProgramPayUrl(options: MiniProgramPayLaunchOptions): string {
  const token = typeof localStorage !== "undefined" ? localStorage.getItem("token") ?? "" : "";
  const returnPath =
    options.returnPath?.trim() ||
    (typeof window !== "undefined"
      ? `${window.location.pathname}${window.location.search}`
      : "/");
  const q = [
    `spaceId=${encodeURIComponent(options.spaceId)}`,
    `orderId=${encodeURIComponent(options.orderId)}`,
    `token=${encodeURIComponent(token)}`,
    `returnPath=${encodeURIComponent(returnPath)}`,
  ].join("&");
  return `${MINIAPP_PAY_PAGE_PATH}?${q}`;
}

/** 小程序 web-view 内跳转原生支付页（微信 wx.requestPayment / 抖音 tt.pay） */
export function navigateToMiniProgramPay(options: MiniProgramPayLaunchOptions): void {
  const url = buildMiniProgramPayUrl(options);
  void loadMiniProgramBridge().then((bridge) => {
    const go = bridge?.miniProgram?.navigateTo;
    if (!go || !bridge?.miniProgram) {
      console.warn("[lf-h5][miniapp-pay] miniProgram.navigateTo unavailable");
      return;
    }
    go.call(bridge.miniProgram, {
      url,
      fail: (err) => console.error("[lf-h5][miniapp-pay] navigateTo fail", url, err),
    });
  });
}
